$(document).ready(function () {
  $(".generalmessage").prependTo("header");
  // execution
  validateCurrentTheme();
  setTimeout(() => {
    $(body).css("opacity", "1");
  }, 500);

  // wrapper function
  function persistTheme() {
    addBodyClass(validateStorage().themeClass);
    redirectHeaderLogo(validateStorage().themeUrl, validateStorage().ticketUrl);
  }

  // function to validate theme status
  function validateCurrentTheme() {
    let currentTheme;
    const bodyClassList = $("body").attr("class")?.split(" ") || [];
    const activeTheme = themeConfig.find((theme) =>
      bodyClassList.includes(theme.themeClass),
    );

    if (activeTheme) {
      redirectHeaderLogo(activeTheme.themeUrl, activeTheme.ticketUrl);
      sessionStorage.setItem("subpage", JSON.stringify(activeTheme));
      currentTheme = activeTheme;
    } else {
      persistTheme();
    }
    return currentTheme;
  }

  // function to add custom class to body
  function addBodyClass(className) {
    $(body).addClass(className);
  }

  // function to redirect logo and ticket btn
  function redirectHeaderLogo(urlToRedirect, ticketUrl) {
    $(".header-logo").attr("href", safeUrl(urlToRedirect));
    $(".ticket-btn").attr("href", safeUrl(ticketUrl));
  }
});

// function to validate storage status
function validateStorage() {
  const themeToValidate = sessionStorage.getItem("subpage");
  if (themeToValidate) {
    try {
      const parsedTheme = JSON.parse(themeToValidate);
      const known = themeConfig.find(
        (t) => t.themeClass === parsedTheme.themeClass,
      );
      if (known) return known;
    } catch (e) {
      console.error("Error parsing theme from sessionStorage:", e);
    }
  }
  return themeConfig[0];
}

// function to sanitize urls
function safeUrl(raw) {
  try {
    const u = new URL(raw, window.location.origin);
    return u.protocol === "https:" || u.protocol === "http:" ? u.href : "#";
  } catch (e) {
    console.error("Invalid URL:", raw, e);
    return "#";
  }
}
